<google-map height="300px" width="100%" [center]="map_options.center" [zoom]="map_options.zoom">
    <map-marker (dragend)="markerDragEndHandler($event)" (mapDragend)="markerDragEndHandler($event)"
        [position]="markerOptions.position" [options]="markerOptions">
    </map-marker>
</google-map>